module.exports = __webpack_public_path__ + "img/beetle_eyes_right.e141c639.png";